"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValidator = exports.getBech32AddressFromEVMAddress = exports.assertAndReturnBech32AddressWordBytes = exports.isValidBech32Address = exports.validateAddress = exports.AddressType = void 0;
var bech32_1 = __importDefault(require("bech32"));
var web3_utils_1 = require("web3-utils");
var bytes_1 = require("./bytes/bytes");
var AddressType;
(function (AddressType) {
    AddressType[AddressType["USER"] = 0] = "USER";
    AddressType[AddressType["VALIDATOR"] = 1] = "VALIDATOR";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
function validateAddress(addressProps) {
    var network = addressProps.network;
    var bech32Decoded = bech32_1.default.decode(addressProps.address);
    switch (addressProps.type) {
        case AddressType.USER:
            return bech32Decoded.prefix === network.addressPrefix;
        case AddressType.VALIDATOR:
            return bech32Decoded.prefix === network.validatorAddressPrefix;
        default:
            return false;
    }
}
exports.validateAddress = validateAddress;
exports.isValidBech32Address = function (addr) {
    try {
        bech32_1.default.decode(addr);
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.assertAndReturnBech32AddressWordBytes = function (addr) {
    try {
        var words = bech32_1.default.decode(addr).words;
        return bytes_1.Bytes.fromUint8Array(new Uint8Array(bech32_1.default.fromWords(words)));
    }
    catch (error) {
        throw new Error('Invalid Bech32 address.');
    }
};
exports.getBech32AddressFromEVMAddress = function (evmAddress, bech32Prefix) {
    if (!web3_utils_1.isAddress(evmAddress)) {
        throw new TypeError('Please provide a valid EVM compatible address.');
    }
    var evmAddrWithoutHexPrefix = web3_utils_1.stripHexPrefix(evmAddress);
    var evmAddressBytes = bytes_1.Bytes.fromHexString(evmAddrWithoutHexPrefix).toUint8Array();
    var words = bech32_1.default.toWords(evmAddressBytes);
    var cronosToBech32Address = bech32_1.default.encode(bech32Prefix, words);
    return cronosToBech32Address;
};
var AddressValidator = (function () {
    function AddressValidator(params) {
        this.params = params;
    }
    AddressValidator.prototype.validate = function () {
        return validateAddress(this.params);
    };
    AddressValidator.prototype.isValid = function () {
        try {
            return validateAddress(this.params);
        }
        catch (_a) {
            return false;
        }
    };
    return AddressValidator;
}());
exports.AddressValidator = AddressValidator;
//# sourceMappingURL=address.js.map